'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Modal = function (_Component) {
  (0, _inherits3.default)(Modal, _Component);

  function Modal() {
    (0, _classCallCheck3.default)(this, Modal);
    return (0, _possibleConstructorReturn3.default)(this, (Modal.__proto__ || (0, _getPrototypeOf2.default)(Modal)).apply(this, arguments));
  }

  (0, _createClass3.default)(Modal, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', {
        className: this.classes
      }, _react2.default.createElement('div', {
        className: 'Modal-content'
      }, _react2.default.createElement('div', {
        className: 'Modal-header'
      }, _react2.default.createElement('div', {
        className: 'Modal-header-title'
      }, this.props.title), _react2.default.createElement('i', {
        className: 'Modal-header-close material-icons',
        onClick: this.props.onDismiss
      }, 'clear')), _react2.default.createElement('div', {
        className: 'Modal-body'
      }, this.props.children)));
    }
  }, {
    key: 'classes',
    get: function get() {
      var className = 'Modal ' + this.props.className;

      if (this.props.isActive) {
        className += ' is-active';
      }

      return className;
    }
  }]);
  return Modal;
}(_react.Component);

Modal.propTypes = {
  className: _propTypes2.default.string,
  isActive: _propTypes2.default.bool,
  onDismiss: _propTypes2.default.func
};
Modal.defaultProps = {
  className: '',
  isActive: false,
  onDismiss: function onDismiss() {}
};
exports.default = Modal;